<template>
	<div class="icon-wrapper">
		<slot></slot>
	</div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.icon-wrapper {
	background: linear-gradient(123.25deg, #f82c5c 0%, #e27240 100%);
	height: 48px;
	width: 48px;
	border-radius: 48px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 24px;
		height: 24px;
		fill: #ffffff;
	}
}
</style>
